// sections_config.js
let sectionsConfig = [];
if(itType){
    sectionsConfig = [
        {
            id: 'section1',
            name:'1',
            title: 'Front Peak',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        },
        {
            id: 'section2',
            name:'2',
            title: 'Front Valance',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        },
        {
            id: 'section3',
            name:'3',
            title: 'Back Peak',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        },
        {
            id: 'section4',
            name:'4',
            title: 'Back Valance',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        },
        {
            id: 'section5',
            name:'5',
            title: 'Back Wall',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        },
        {
            id: 'section6',
            name:'6',
            title: 'Right Peak',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        },
        {
            id: 'section7',
            name:'7',
            title: 'Right Valance',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        },
        {
            id: 'section8',
            name:'8',
            title: 'Right Wall',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        },
        {
            id: 'section9',
            name:'9',
            title: 'Left Peak',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        },
        {
            id: 'section10',
            name:'10',
            title: 'Left Valance',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        },
        {
            id: 'section11',
            name:'11',
            title: 'Left Wall',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        }    
    ];
}
else{
    sectionsConfig = [
        {
            id: 'section1',
            name:'1',
            title: 'Front Peak',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        },
        {
            id: 'section2',
            name:'2',
            title: 'Front Valance',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        },
        {
            id: 'section3',
            name:'3',
            title: 'Back Peak',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        },
        {
            id: 'section4',
            name:'4',
            title: 'Back Valance',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        },
        {
            id: 'section5',
            name:'5',
            title: 'Right Peak',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        },
        {
            id: 'section6',
            name:'6',
            title: 'Right Valance',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        },
        {
            id: 'section8',
            name:'7',
            title: 'Left Peak',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        },
        {
            id: 'section9',
            name:'8',
            title: 'Left Valance',
            colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
        },  
    ];
}
